import { useState } from "react";
import { toast } from "react-toastify";
import useAuthUserOtpVerify from "../../../../../../api/hooks/hooks-auth/use-auth-user-otp-verify";
import useAuthUserPatch from "../../../../../../api/hooks/hooks-auth/use-auth-patch-user";
import { transformPhone } from "../../../../../../lib/utils";

export interface IUserData {
  numberPhone: string | null;
  otp: string | null;
  firstName: string | null;
  lastName: string | null;
  patronymic?: string | null;
  marketingConsent?: boolean;
  privacyPolicyConsent: boolean;
  personalDataConsent: boolean;
}

export type TUserDataKeys = keyof IUserData;

const INITIAL_USER_DATA = {
  numberPhone: null,
  otp: null,
  firstName: null,
  lastName: null,
  marketingConsent: false,
  privacyPolicyConsent: false,
  personalDataConsent: false,
};

const useSignUp = () => {
  const [userForm, setUserForm] = useState<IUserData>(INITIAL_USER_DATA);

  const handleChange = (key: TUserDataKeys, data: string | boolean) => {
    setUserForm((prev) => {
      return { ...prev, [key]: data };
    });
  };

  const {
    data: dataAuthUserOtpVerify,
    error: authUserOtpVerifyError,
    isMutating: authUserOtpVerifyIsMutating,
    trigger: authUserOtpVerifyTrigger,
  } = useAuthUserOtpVerify();

  const {
    error: authUserPatchError,
    isMutating: authUserPatchIsMutating,
    trigger: authUserPatchTrigger,
  } = useAuthUserPatch();

  const handleSendData = async () => {
    if (
      userForm.numberPhone &&
      userForm.otp &&
      userForm.lastName &&
      userForm.firstName
    ) {
      try {
        await authUserOtpVerifyTrigger({
          phone: transformPhone(userForm.numberPhone),
          otpCode: userForm.otp,
        });
        await authUserPatchTrigger({
          lastName: userForm.lastName,
          firstName: userForm.firstName,
          patronymic: userForm.patronymic ? userForm.patronymic : undefined,
        });
        toast.success("Вы заргистрированы");
      } catch (error) {
        toast.error("Ошибка. Не удалось зарегистрироваться, проверьте данные.");
      }
    }
  };

  return {
    handleSignUp: handleSendData,
    handleChange,
    userForm,
    token: dataAuthUserOtpVerify,
  };
};

export default useSignUp;
